import { render, staticRenderFns } from "./CategoriesSidepanel.vue?vue&type=template&id=6081a678&"
import script from "./CategoriesSidepanel.vue?vue&type=script&lang=js&"
export * from "./CategoriesSidepanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports